import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { withAiToolNestedParamSchema } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { ormToolQueryArgsSchema } from '@erikdakoda/ai-tool/types';
import { createPromptSelectSchema } from './botAiToolInputSchemas';
import { PromptForAiToolsSchema } from './PromptForAiTools';

export const createPromptBodySchema = PromptForAiToolsSchema.omit({
  id: true,
  slug: true,
  updatedAt: true,
});

export const createPromptInputSchema = z.object({
  prompt: withAiToolNestedParamSchema(createPromptBodySchema, 'prompt').describe(
    'Prompt to create, including ownerId and spaceId.',
  ),
  select: createPromptSelectSchema,
});

export const createPromptOutputSchema = z.object({
  queryArgs: ormToolQueryArgsSchema,
  queryResult: z
    .unknown()
    .nullable()
    .describe('Created row; default mask when `select` omitted, else matches caller `select`.'),
  success: z.string().nullable(),
  error: z.unknown().nullable(),
});

export type CreatePromptInput = z.infer<typeof createPromptInputSchema>;
export type CreatePromptOutput = z.infer<typeof createPromptOutputSchema>;

export const createPrompt: AiTool<undefined, CreatePromptInput, CreatePromptOutput> = {
  id: 'createPrompt',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: 'Create a reusable prompt for a user and space.',
    inputSchema: zodSchema(createPromptInputSchema),
    outputSchema: zodSchema(createPromptOutputSchema),
  }),
};
